import { render, staticRenderFns } from "./action-buttons.vue?vue&type=template&id=1b1258ea&"
import script from "./action-buttons.component.ts?vue&type=script&lang=ts&"
export * from "./action-buttons.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports